import React from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import HowItWorks from "@/components/HowItWorks";
import FindMyCar from "@/components/FindMyCar";
import SellTrade from "@/components/SellTrade";
import WhyStrive from "@/components/WhyStrive";
import SuccessStories from "@/components/SuccessStories";
import RecentlySourced from "@/components/RecentlySourced";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import StickyCall from "@/components/StickyCall";
import ConciergeChat from "@/components/ConciergeChat";

export default function Home() {
  return (
    <>
      <a
        href="#find"
        data-testid="skip-to-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:bg-[#E31E24] focus:text-white focus:px-4 focus:py-2 focus:font-mono2 focus:uppercase focus:tracking-[0.14em] focus:text-sm"
      >
        Skip to Find My Car
      </a>
      <main data-testid="home-page" className="relative" id="main">
        <Nav />
        <Hero />
        <Marquee />
        <HowItWorks />
        <FindMyCar />
        <SellTrade />
        <WhyStrive />
        <SuccessStories />
        <RecentlySourced />
        <FAQ />
        <Footer />
        <StickyCall />
        <ConciergeChat />
      </main>
    </>
  );
}
